// CORE
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

// PLUGINS
import { Drivers } from '@ionic/storage';
import { IonicStorageModule } from '@ionic/storage-angular';
import { HttpClientModule } from '@angular/common/http';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { StreamingMedia } from '@awesome-cordova-plugins/streaming-media/ngx';
import { PhotoViewer } from '@awesome-cordova-plugins/photo-viewer/ngx';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { Market } from '@ionic-native/market/ngx';
import { MediaCapture } from '@awesome-cordova-plugins/media-capture/ngx';
import { OpenNativeSettings } from '@awesome-cordova-plugins/open-native-settings/ngx';
import { VideoEditor } from '@awesome-cordova-plugins/video-editor/ngx';

// FONT AWESOME
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

// MODULE
import { ScrollingModule } from '@angular/cdk/scrolling';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { AngularCropperjsModule } from 'angular-cropperjs';
import { SwiperModule } from 'swiper/angular';
import { PdfViewerModule } from 'ng2-pdf-viewer';

// CONFIG
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    FontAwesomeModule,
    IonicStorageModule.forRoot({
      name: 'MyPASM',
      driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
    }),
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    ScrollingModule,
    LazyLoadImageModule,
    AngularCropperjsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    SwiperModule,
    PdfViewerModule,
  ],
  providers: [
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy
    },
    File,
    StreamingMedia,
    PhotoViewer,
    VideoEditor,
    Market,
    Device,
    AppVersion,
    InAppBrowser,
    SplashScreen,
    MediaCapture,
    OpenNativeSettings,
  ],
  bootstrap: [AppComponent],
})

export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas, fab, far);
  }
}
